import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { ReactComponent as GenAiIcon } from 'new/components/icons/genai.svg';
import { ReactComponent as NexsetIcon } from 'new/components/icons/fi-rr-apps.svg';
import { ReactComponent as NexsetDetailsIcon } from 'new/components/icons/fi-rr-search.svg';
import CloseIcon from '@mui/icons-material/Close';
import styles from './ChatHeader.module.scss';
import { useResourceDetailHandler } from 'new/components/ResourceDetailHandler/context';

interface ChatHeaderProps {
  onClose: () => void;
  onMouseDown?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  withNexsetBadge?: boolean;

  nexsetName?: string;
  selectedNexsetData?: any;

  headerTitle?: string;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({
  onClose,
  onMouseDown,
  withNexsetBadge,
  nexsetName,
  selectedNexsetData,
  headerTitle = 'Generate a Data Product with Natural Language',
}) => {
  const { openDetailDrawerInPortal } = useResourceDetailHandler();

  const onDetailClicked = (e) => {
    e.stopPropagation();
    openDetailDrawerInPortal({ ...selectedNexsetData, type: 'DATA_SET' }, {});
  };

  return (
    <Box className={styles.chatHeader} onMouseDown={onMouseDown}>
      <Box className={styles.genAiHeader}>
        <Typography className={styles.genAiTitle}>
          <GenAiIcon className={styles.genAiIcon} />
          {headerTitle}
        </Typography>
        <IconButton className={styles.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      {withNexsetBadge && (
        <Box className={styles.idContainer}>
          <Box className={styles.idIconContainer}>
            <NexsetIcon className={styles.idIcon} />
            {nexsetName && <Typography className={styles.idText}>{nexsetName}</Typography>}
          </Box>

          {selectedNexsetData && (
            <IconButton className={styles.detailButton} onClick={onDetailClicked}>
              <NexsetDetailsIcon
                style={{
                  padding: 0,
                }}
              />
            </IconButton>
          )}
        </Box>
      )}
    </Box>
  );
};

export default ChatHeader;
